export const LANGUAGE_CODES: { [key: string]: string } = {
  es: 'es',
  en: 'en',
};

export const SPRITESHEET_URL = `${process.env.DOMAIN}/symbol/svg/sprite.symbol.svg`;

interface KeyCodeMap {
  [key: string]: number;
}

export const KEYCODES: KeyCodeMap = {
  ESCAPE: 27,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
};

interface KeyMap {
  [key: string]: string;
}

export const KEYS: KeyMap = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ESCAPE: 'Escape',
  TAB: 'Tab',
  ENTER: 'Enter',
};
